import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';

function RequireAuth() {
  const { data: user } = useGetProfileQuery();
  const location = useLocation();

  return user ? <Outlet /> : <Navigate to="/login" state={{ next: `${location.pathname}${location.search}` }} />;
}

export default RequireAuth;
